import { createSlice } from '@reduxjs/toolkit';
import { Map, List, fromJS } from 'immutable';
import { DateTime } from 'luxon';

const initialState = fromJS({
	job_id: null,
	schedule_id: null,
	color: '#2196f3',
	visible: true,
	dates: {
		overall_job: {
			days_of_week: [],
			start_date: null,
			end_date: null,
			// start_time: '07:00',
			// end_time: '17:00',
			start_time: '',
			end_time: '',
		},
		crews: {},
		equipment: {},
		people: {},
	},
	all_days: [],
	ui: {
		selectedResourceType: 'overall_job',
		selectedResourceId: null,
		isUpdatingDays: false,
		isLoadingResource: false,
		isMinimized: false,
		searchQuery: '',
		isLoading: true,
		reset_all_dates: true,
	}
});

const scheduleSlice = createSlice({
	name: 'schedule',
	initialState,
	reducers: {
		loadSchedule: (state, action) => {
			const newSchecule = action.payload;
			// const { job_id, schedule_id, dates, all_days } = action.payload;
			return state
				.merge(newSchecule)
				.set('isLoading', false);
				// .set('job_id', job_id)
				// .set('schedule_id', schedule_id)
				// .set('dates', dates))
				// .set('all_days', fromJS(all_days));
		},

		initializeSchedule: (state, action) => {
			const { job_id, startDate, endDate } = action.payload;
			return state
				.set('job_id', job_id)
				.set('schedule_id', `${job_id}_schedule_${Date.now()}`)
				.setIn(['dates', 'overall_job', 'start_date'], startDate)
				.setIn(['dates', 'overall_job', 'end_date'], endDate);
		},

		setSelectedResource: (state, action) => {
			const { resourceType, resourceId } = action.payload;
			return state
				.setIn(['ui', 'selectedResourceType'], resourceType)
				.setIn(['ui', 'selectedResourceId'], resourceId);
		},

		updateDateRange: (state, action) => {
			const { resourceKey, updates } = action.payload;
			
			if (resourceKey === 'overall_job') {
				const path = ['dates', 'overall_job'];
				return state.mergeIn(path, fromJS(updates));
			}
			
			const { type, id } = resourceKey;
			const path = ['dates', type, id];
			console.log('updates here ', updates);
			
			if (!state.hasIn(path)) {
				const overallJob = state.getIn(['dates', 'overall_job']);
				const newData = overallJob.merge(fromJS(updates));
				return state.setIn(path, newData);
			}
			
			return state.mergeIn(path, fromJS(updates));
		},

		updateDaySchedule: (state, action) => {
			const { dateId, resourceKey, updates } = action.payload;
			console.log('updates', updates);
			let dayIndex = state.get('all_days')
				.findIndex(day => day.get('date') === dateId);
			
			if (dayIndex === -1) {
				const newDay = fromJS({
					_id: dateId,
					date: dateId,
					schedule_id: state.get('schedule_id'),
					overall_job: {
						is_working: false,
						start_time: '07:00',
						end_time: '17:00',
					}
				});
				
				state = state.update('all_days', days => days.push(newDay));
				dayIndex = state.get('all_days').size - 1;
			}
			
			let path;
			if (resourceKey === 'overall_job') {
				path = ['all_days', dayIndex, 'overall_job'];
			} else {
				const { type, id } = resourceKey;
				path = ['all_days', dayIndex, type, id];
			}
			
			const currentData = state.getIn(path);
			
			if (currentData) {
				const updatedData = currentData.merge(fromJS(updates));
				return state.setIn(path, updatedData);
			} else {
				const overallJob = state.getIn(['all_days', dayIndex, 'overall_job']);
				const newResourceData = overallJob.merge(fromJS(updates));
				return state.setIn(path, newResourceData);
			}
		},

		toggleDayWorking: (state, action) => {
			const { dateId, resourceKey } = action.payload;
			let dayIndex = state.get('all_days')
				.findIndex(day => day.get('date') === dateId);
			
			if (dayIndex === -1) {
				const newDay = fromJS({
					_id: dateId,
					date: dateId,
					schedule_id: state.get('schedule_id'),
					overall_job: {
						is_working: false,
						start_time: '07:00',
						end_time: '17:00',
					}
				});
				
				state = state.update('all_days', days => days.push(newDay));
				dayIndex = state.get('all_days').size - 1;
			}
			
			let path, checkPath;
			if (resourceKey === 'overall_job') {
				path = ['all_days', dayIndex, 'overall_job', 'is_working'];
				checkPath = ['all_days', dayIndex, 'overall_job'];
			} else {
				const { type, id } = resourceKey;
				path = ['all_days', dayIndex, type, id, 'is_working'];
				checkPath = ['all_days', dayIndex, type, id];
			}
			
			const currentValue = state.getIn(path);
			
			if (currentValue === undefined || currentValue === null) {
				const overallJob = state.getIn(['all_days', dayIndex, 'overall_job']);
				const newData = overallJob.set('is_working', true);
				return state.setIn(checkPath, newData);
			}
			
			return state.setIn(path, !currentValue);
		},

		applySettingsToAllDays: (state, action) => {
			const { resourceKey, startDate, endDate, daysOfWeek, startTime, endTime } = action.payload;
			
			const dateUpdates = {
				start_date: startDate.toISODate(),
				end_date: endDate.toISODate(),
				start_time: startTime,
				end_time: endTime,
				days_of_week: daysOfWeek,
			};
			
			if (resourceKey === 'overall_job') {
				const path = ['dates', 'overall_job'];
				state = state.mergeIn(path, fromJS(dateUpdates));
			} else {
				const { type, id } = resourceKey;
				const path = ['dates', type, id];
				if (!state.hasIn(path)) {
					const overallJob = state.getIn(['dates', 'overall_job']);
					state = state.setIn(path, overallJob.merge(fromJS(dateUpdates)));
				} else {
					state = state.mergeIn(path, fromJS(dateUpdates));
				}
			}
			
			const shouldResetAllDates = resourceKey === 'overall_job' && state.getIn(['ui', 'reset_all_dates']);
			
			if (shouldResetAllDates) {
				state = state.setIn(['dates', 'crews'], fromJS({}));
				state = state.setIn(['dates', 'equipment'], fromJS({}));
				state = state.setIn(['dates', 'people'], fromJS({}));
				
				const newDays = [];
				let currentDate = startDate;
				
				while (currentDate <= endDate) {
					const dateId = currentDate.toISODate();
					const dayOfWeek = currentDate.weekday % 7;
					const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
					const dayName = dayNames[dayOfWeek];
					const isWorking = daysOfWeek.includes(dayName);
					
					const dayObj = {
						_id: dateId,
						date: dateId,
						schedule_id: state.get('schedule_id'),
						overall_job: {
							is_working: isWorking,
							start_time: startTime,
							end_time: endTime,
						}
					};
					
					newDays.push(fromJS(dayObj));
					currentDate = currentDate.plus({ days: 1 });
				}
				
				state = state.set('all_days', fromJS(newDays));
				return state;
			}
			
			let allDays = state.get('all_days');
			
			const existingDaysMap = {};
			if (allDays && allDays.size > 0) {
				allDays.forEach(day => {
					existingDaysMap[day.get('date')] = day;
				});
			}
			
			let currentDate = startDate;
			
			while (currentDate <= endDate) {
				const dateId = currentDate.toISODate();
				const dayOfWeek = currentDate.weekday % 7;
				const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
				const dayName = dayNames[dayOfWeek];
				const isWorking = daysOfWeek.includes(dayName);
				
				const scheduleData = fromJS({
					is_working: isWorking,
					start_time: startTime,
					end_time: endTime,
				});
				
				if (existingDaysMap[dateId]) {
					let existingDay = existingDaysMap[dateId];
					
					if (resourceKey === 'overall_job') {
						existingDay = existingDay.set('overall_job', scheduleData);
					} else {
						const { type, id } = resourceKey;
						existingDay = existingDay.setIn([type, id], scheduleData);
					}
					
					existingDaysMap[dateId] = existingDay;
				} else {
					const dayObj = {
						_id: dateId,
						date: dateId,
						schedule_id: state.get('schedule_id'),
						overall_job: resourceKey === 'overall_job' ? {
							is_working: isWorking,
							start_time: startTime,
							end_time: endTime,
						} : {
							is_working: false,
							start_time: '07:00',
							end_time: '17:00',
						}
					};
					
					if (resourceKey !== 'overall_job') {
						const { type, id } = resourceKey;
						dayObj[type] = {
							[id]: {
								is_working: isWorking,
								start_time: startTime,
								end_time: endTime,
							}
						};
					}
					
					existingDaysMap[dateId] = fromJS(dayObj);
				}
				
				currentDate = currentDate.plus({ days: 1 });
			}
			
			const sortedDays = Object.keys(existingDaysMap)
				.sort()
				.map(dateId => existingDaysMap[dateId]);
			
			state = state.set('all_days', fromJS(sortedDays));
			
			return state;
		},

		// regenerateAllDays: (state, action) => {
		// 	const { resourceKey, startDate, endDate, daysOfWeek, startTime, endTime } = action.payload;
			
		// 	const existingDays = state.get('all_days');
		// 	const daysMap = {};
			
		// 	// First, preserve all existing day data in a map
		// 	if (existingDays) {
		// 		existingDays.forEach(day => {
		// 			daysMap[day.get('id')] = day;
		// 		});
		// 	}
			
		// 	// Now update/create days for the current date range
		// 	const days = [];
		// 	let currentDate = startDate;
			
		// 	while (currentDate <= endDate) {
		// 		const dayOfWeek = currentDate.weekday % 7;
		// 		const dateId = currentDate.toISODate();
		// 		const isWorking = daysOfWeek.includes(dayOfWeek);
				
		// 		// Get existing day or create new one
		// 		let dayData = daysMap[dateId];
				
		// 		if (!dayData) {
		// 			// Create new day with overall_job defaults
		// 			dayData = fromJS({
		// 				id: dateId,
		// 				overall_job: {
		// 					is_working: true,
		// 					start_time: startTime,
		// 					end_time: endTime,
		// 				}
		// 			});
		// 		}
				
		// 		// Update the specific resource data
		// 		if (resourceKey === 'overall_job') {
		// 			dayData = dayData.setIn(['overall_job', 'is_working'], isWorking);
		// 			dayData = dayData.setIn(['overall_job', 'start_time'], startTime);
		// 			dayData = dayData.setIn(['overall_job', 'end_time'], endTime);
		// 		} else {
		// 			// Update resource-specific data
		// 			dayData = dayData.set(resourceKey, fromJS({
		// 				is_working: isWorking,
		// 				start_time: startTime,
		// 				end_time: endTime,
		// 			}));
		// 		}
				
		// 		days.push(dayData);
		// 		currentDate = currentDate.plus({ days: 1 });
		// 	}
			
		// 	return state.set('all_days', fromJS(days));
		// },



		setUIUpdatingDays: (state, action) => {
			return state.setIn(['ui', 'isUpdatingDays'], action.payload);
		},

		setUILoadingResource: (state, action) => {
			return state.setIn(['ui', 'isLoadingResource'], action.payload);
		},

		setUIMinimized: (state, action) => {
			return state.setIn(['ui', 'isMinimized'], action.payload);
		},

		setUISearchQuery: (state, action) => {
			return state.setIn(['ui', 'searchQuery'], action.payload);
		},

		setUIResetAllDates: (state, action) => {
			return state.setIn(['ui', 'reset_all_dates'], action.payload);
		},

		setColor: (state, action) => {
			return state.set('color', action.payload);
		},

		setVisible: (state, action) => {
			return state.set('visible', action.payload);
		},

		resetSchedule: (state) => {
			return initialState;
		},
	}
});

export const {
	loadSchedule,
	initializeSchedule,
	setSelectedResource,
	updateDateRange,
	updateDaySchedule,
	toggleDayWorking,
	applySettingsToAllDays,
	regenerateAllDays,
	setUIUpdatingDays,
	setUILoadingResource,
	setUIMinimized,
	setUISearchQuery,
	setUIResetAllDates,
	setColor,
	setVisible,
	resetSchedule,
} = scheduleSlice.actions;

export default scheduleSlice.reducer;
